import React, { useState } from 'react';

import { useBeraReportV2 } from '@/context/BeraReportV2';

import { Player } from './Player';
import { Timeline } from './Timeline';

import type { PlayerProgress } from './Player';

interface PlaybackProps {
	children: JSX.Element;
}

export function Playback({ children }: Readonly<PlaybackProps>): JSX.Element {
	const { playerRef, isVideoUnavailable, onKeepLoop } = useBeraReportV2();

	const [isPlayerVisible, setIsPlayerVisible] = useState<boolean>(true);
	const [currentTime, setCurrentTime] = useState<number>(0);

	const isPlayerShown = isPlayerVisible && !isVideoUnavailable;

	function handleClosePlayer(): void {
		setIsPlayerVisible(false);
	}

	function handleSeek(time: number): void {
		const player = playerRef.current;

		if (player?.isCollapsed()) {
			player.expandAndSeekTo(time);
		} else {
			player?.seekTo(time);
		}

		setCurrentTime(time);
	}

	function handleProgress({ playedSeconds }: PlayerProgress): void {
		setCurrentTime(playedSeconds);

		onKeepLoop(playedSeconds);
	}

	return (
		<>
			{isPlayerShown && <Player onProgress={handleProgress} onClose={handleClosePlayer} />}
			{children}
			<Timeline currentTime={currentTime} onSeek={handleSeek} />
		</>
	);
}
